import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetooustationcabs() {



 const cardData =
{
  keyword: 'Pune to Outstations Cabs',

  heading: 'Lotus Cab: Pune to Outstations Cabs',

  headingDescription:
    "Lotus Cabs offers reliable and affordable Pune to Outstations Cabs for business travel, family vacations, pilgrimage tours, corporate trips, weekend getaways, and one-way or round-trip journeys across Maharashtra and India. We provide a premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus vehicles driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Pune, well-maintained vehicles, and safe long-distance travel, Lotus Cabs ensures a comfortable, convenient, and hassle-free outstation cab experience for every passenger.",


  top: 'Top Places to Visit from Pune with Lotus Cab',

topPlaces: [
    {
        title: "Mumbai",
        description:
            "Mumbai is one of the most frequently booked outstation destinations from Pune, attracting business professionals, tourists, students, and families throughout the year. Travelers visit Mumbai for corporate meetings, Mumbai International Airport transfers, sightseeing, shopping, medical appointments, and leisure trips. Lotus Cabs provides comfortable door-to-door taxi services with flexible one-way and round-trip options for a seamless travel experience."
    },
    {
        title: "Goa",
        description:
            "Goa is a favorite holiday destination for travelers booking outstation cabs from Pune. Famous for its pristine beaches, Portuguese heritage, nightlife, water sports, churches, and luxury resorts, Goa attracts families, couples, and groups throughout the year. Lotus Cabs offers safe and comfortable long-distance travel with experienced chauffeurs for memorable road trips."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of India's most visited pilgrimage destinations and is renowned for the sacred Sai Baba Temple. Thousands of devotees travel from Pune every week for darshan, religious ceremonies, and family pilgrimages. Lotus Cabs provides reliable outstation taxi services with flexible schedules, ensuring a peaceful and comfortable spiritual journey."
    },
    {
        title: "Nashik",
        description:
            "Nashik is a renowned religious and wine tourism destination famous for Trimbakeshwar Jyotirlinga, Panchavati, Godavari Ghats, and premium vineyards. Visitors from Pune frequently book outstation cabs for pilgrimage tours, wine experiences, family vacations, and business travel. Lotus Cabs offers safe highway journeys with professional drivers."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is one of Maharashtra's most popular hill stations, known for strawberry farms, scenic viewpoints, Venna Lake, waterfalls, and cool weather throughout the year. Families, honeymoon couples, and weekend travelers regularly choose Lotus Cabs for comfortable road trips from Pune to enjoy the natural beauty of the Western Ghats."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is a historic city famous for the Mahalaxmi Temple, royal heritage, traditional cuisine, and cultural attractions. It is a preferred destination for pilgrimage, family holidays, and business travel from Pune. Lotus Cabs offers reliable outstation taxi services with spacious vehicles suitable for both short and extended journeys."
    },
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a beautiful Konkan coastal destination known for Ganpatipule Temple, pristine beaches, Alphonso mango orchards, sea forts, and scenic coastal highways. Travelers from Pune often choose Lotus Cabs for comfortable road trips to experience the region's natural beauty, seafood, and peaceful seaside atmosphere."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is a heritage city famous for the UNESCO-listed Ajanta and Ellora Caves, Grishneshwar Jyotirlinga, Bibi Ka Maqbara, and Daulatabad Fort. It is one of the most popular historical and pilgrimage destinations from Pune. Lotus Cabs ensures a comfortable and enjoyable journey for families, tourists, and history enthusiasts."
    },
    {
        title: "Pandharpur",
        description:
            "Pandharpur is Maharashtra's most important pilgrimage destination dedicated to Lord Vitthal and Goddess Rukmini. Devotees from Pune frequently book outstation cabs for temple visits, Ashadhi and Kartiki Yatra, and religious functions. Lotus Cabs provides dependable transportation with comfortable vehicles for pilgrims of all age groups."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a picturesque hill station located close to Pune and is famous for Bhushi Dam, Tiger Point, Karla Caves, Rajmachi Fort, and lush green valleys. It is one of the most preferred weekend destinations for families, couples, and corporate groups. Lotus Cabs offers convenient outstation taxi services for relaxing and enjoyable short trips."
    }
],






  "services": [
    {
      "name": "Pune to Outstation Cab",
      "description": "Book Pune to outstation cab services for one-way, round trip, or multi-day travel across Maharashtra and neighboring states. Choose from sedan and SUV vehicles with professional drivers, transparent per km rates, and flexible pickup options from home, airport, or railway station."
    },
    {
      "name": "Outstation Taxi Service Pune",
      "description": "Reliable outstation taxi service in Pune for long-distance travel including Mumbai, Nashik, Shirdi, Goa, Kolhapur, and more. Well-maintained AC vehicles, clear fare structure, and comfortable seating ensure safe and smooth highway journeys."
    },
    {
      "name": "One Way Cab Pune",
      "description": "Affordable one way cab Pune options for intercity travel without paying for return distance. Ideal for airport drops, business travel, and relocation trips with transparent billing and flexible departure timing."
    },
    {
      "name": "Outstation Car Rental Pune",
      "description": "Outstation car rental in Pune available for daily, weekend, or extended trips. Choose from Swift Dzire, Ertiga, Kia Carens, and Innova Crysta with per km or per day pricing options suited for family and corporate travel."
    },
    {
      "name": "Pune to Outstation Taxi",
      "description": "Comfortable Pune to outstation taxi booking for family trips, pilgrimage tours, and corporate travel. Transparent fare breakdown, driver allowance clarity, and toll information provided before booking confirmation."
    },
    {
      "name": "PCMC to Outstation Cab Booking",
      "description": "Convenient PCMC and Pimpri Chinchwad to outstation cab booking with doorstep pickup. Available for one-way drops and round trips with affordable pricing and professional drivers."
    },
    {
      "name": "Book Innova Crysta for Outstation",
      "description": "Spacious Innova Crysta booking for outstation travel suitable for large families and corporate groups. Premium comfort, ample luggage space, and smooth ride quality make it ideal for long-distance journeys."
    },
    {
      "name": "Book Ertiga for Outstation in Pune",
      "description": "Affordable Ertiga rental for outstation trips from Pune with comfortable seating for small groups. Per km rate and daily rental options available for highway travel."
    },
    {
      "name": "Swift Dzire on Rent in Pune for Outstation",
      "description": "Budget-friendly Swift Dzire sedan rental for outstation travel from Pune. Suitable for couples and small families with economical per km pricing and comfortable AC travel."
    },
    {
      "name": "Sedan Cab for Outstation",
      "description": "Sedan cab for outstation travel offering comfortable seating, smooth highway performance, and affordable pricing. Ideal for short to mid-distance routes with flexible travel options."
    },
    {
      "name": "Kia Carens Rent for Outstation in Pune",
      "description": "Kia Carens rental for outstation travel providing spacious interiors and premium comfort. Suitable for family road trips and long-distance journeys with transparent fare structure."
    }
  ],

  "tableData": [
    ["Pune to Outstation Cab", "Outstation Taxi Service Pune"],
    ["One Way Cab Pune", "Outstation Car Rental Pune"],
    ["Pune to Outstation Taxi", "PCMC to Outstation Cab Booking"],
    ["Book Innova Crysta for Outstation", "Book Ertiga for Outstation in Pune"],
    ["Swift Dzire on Rent in Pune for Outstation", "Sedan Cab for Outstation"],
    ["Kia Carens Rent for Outstation in Pune", ""]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Outstation Cab Services",
      "WhyChoosedescription": "Well-maintained vehicles and experienced drivers ensure comfortable long-distance travel from Pune to major cities and tourist destinations."
    },
    {
      "WhyChooseheading": "Transparent Per KM Pricing",
      "WhyChoosedescription": "Clear billing structure with detailed breakdown of base fare, per kilometer rate, driver allowance, tolls, and parking charges."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options",
      "WhyChoosedescription": "Choose from sedan, SUV, and premium MPV categories including Swift Dzire, Ertiga, Kia Carens, and Innova Crysta based on travel needs."
    },
    {
      "WhyChooseheading": "One Way & Round Trip Flexibility",
      "WhyChoosedescription": "Flexible booking for one-way drop taxi, round trip, or multi-day outstation rental with convenient pickup and return scheduling."
    },
    {
      "WhyChooseheading": "24/7 Booking Assistance",
      "WhyChoosedescription": "Round-the-clock support for booking confirmation, fare inquiries, route planning, and travel assistance."
    }
  ]
}


const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to outstation cab services?',
    answer: 'Yes, Lotus Cab offers reliable Pune to outstation cab services for one-way and round trips to destinations like Mumbai, Mahabaleshwar, Shirdi, Nashik, Goa, Kolhapur, and many more across Maharashtra and nearby states.',
  },
  {
    question: 'What are the charges for Pune to outstation cabs?',
    answer: 'Outstation cab charges from Pune depend on distance, vehicle type (Sedan or SUV), and trip type (one-way or round trip). Lotus Cab provides transparent per km pricing with no hidden charges.',
  },
  {
    question: 'Can I book a one-way Pune to outstation cab?',
    answer: 'Yes, Lotus Cab offers affordable one-way outstation cab services from Pune, allowing customers to pay only for the drop without return charges.',
  },
  {
    question: 'Which vehicles are available for Pune to outstation trips?',
    answer: 'We provide well-maintained Sedan cars like Dzire and Etios, as well as SUVs like Ertiga and Innova Crysta for comfortable long-distance travel from Pune.',
  },
  {
    question: 'Are toll and parking charges included in Pune to outstation cab fare?',
    answer: 'Toll, parking, and state taxes are charged separately as per actuals. Lotus Cab maintains full transparency and informs customers about all applicable costs before trip confirmation.',
  },
  {
    question: 'Is Lotus Cab available for multi-day outstation trips from Pune?',
    answer: 'Yes, we provide flexible multi-day outstation cab packages from Pune for family vacations, business tours, pilgrimage trips, and corporate travel.',
  },
  {
    question: 'How can I get a fare estimate for Pune to outstation cab booking?',
    answer: 'You can contact Lotus Cab with your pickup location, destination, travel dates, and vehicle preference to receive an instant and accurate fare estimate.',
  },
  {
    question: 'Do you provide Pune to outstation airport drop services?',
    answer: 'Yes, Lotus Cab offers direct outstation airport drop and pickup services from Pune to Mumbai Airport, Navi Mumbai Airport, and other major airports.',
  },
  {
    question: 'Are drivers experienced for long-distance travel?',
    answer: 'All Lotus Cab drivers are experienced, licensed, and familiar with major highways and routes, ensuring a safe and smooth outstation travel experience.',
  },
  {
    question: 'Is advance booking required for Pune to outstation cabs?',
    answer: 'While same-day bookings are available, we recommend advance booking for outstation trips to ensure vehicle availability and the best pricing.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Kulkarni',
    feedback: 'Booked Lotus Cab for Pune to Mahabaleshwar outstation trip. The cab was clean, driver was professional, and pricing was completely transparent. Highly recommended.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Priya Patil',
    feedback: 'Excellent Pune to outstation cab service by Lotus Cab. We traveled to Shirdi comfortably with family. Smooth ride, punctual driver, and reasonable fare.',
    rating: 5,
  },
];




































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];




const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Outstation Cabs",
"image": "https://lotuscab.com/assets/images/pune-to-outstation-cabs.jpg",
"description": "Book Pune to Outstation Cabs with Lotus Cab for affordable, safe, and comfortable intercity travel. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 at budget-friendly fares.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5927"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-outstation-cabs"
}
};












  return (
    <div>
      

<Helmet>
  <title>Pune to Outstation Cabs | Affordable Outstation Taxi Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Outstation Cabs with Lotus Cab for affordable one way and round trip taxi services. Travel comfortably in Sedan, SUV, and AC cabs with professional drivers, instant booking, and 24x7 customer support."
/>

<meta
 name="keywords"
 content="Pune to Outstation Cabs, Pune Outstation Cab, Outstation Taxi Pune, Pune Outstation Taxi Service, One Way Outstation Cab Pune, Round Trip Outstation Cab Pune, Intercity Taxi Pune, Pune to Mumbai Cab, Pune to Nashik Cab, Pune to Shirdi Cab, Pune to Kolhapur Cab, Pune to Goa Cab, Affordable Outstation Cab Pune, Cheap Outstation Taxi Pune, Online Outstation Cab Booking Pune, Sedan Outstation Cab Pune, SUV Outstation Cab Pune, Best Outstation Cab Pune, Lotus Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/75.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetooustationcabs;